import { ReactComponent as CardsImage } from 'images/getStarted/cards.svg';
import { ReactComponent as WalletImage } from 'images/getStarted/wallet.svg';
import { ReactComponent as DocsImage } from 'images/getStarted/docs.svg';

export const firstSteps = {
  id: 'firstStep',
  label: 'getStarted.firstSteps.label',
  items: [
    {
      id: 'testCards',
      image: <CardsImage />,
      label: 'getStarted.firstSteps.testCards.label',
      text: 'getStarted.firstSteps.testCards.text',
      link: 'test_cards',
    },
    {
      id: 'manualPayments',
      image: <WalletImage />,
      label: 'getStarted.firstSteps.manualPayments.label',
      text: 'getStarted.firstSteps.manualPayments.text',
      link: '/manual-payments',
    },
    {
      id: 'paymentTypes',
      image: <DocsImage />,
      label: 'getStarted.firstSteps.paymentTypes.label',
      text: 'getStarted.firstSteps.paymentTypes.text',
      link: '/payments',
    },
  ],
};

export const technicalDocumentation = {
  id: 'technicalDocumentation',
  label: 'getStarted.documetation.label',
  items: [
    {
      id: 'generalDocumentation',
      image: 'im-Edit',
      label: 'getStarted.documetation.generalDocumentation.label',
      text: 'getStarted.documetation.generalDocumentation.text',
      link: 'general',
    },
    {
      id: 'api',
      image: 'im-List',
      label: 'getStarted.documetation.API.label',
      text: 'getStarted.documetation.API.text',
      link: 'api_reference',
    },
    {
      id: 'pp',
      image: 'im-Browser',
      label: 'getStarted.documetation.PP.label',
      text: 'getStarted.documetation.PP.text',
      link: 'payment_page_integration',
    },
    {
      id: 'payoutsAPI',
      image: 'im-Code',
      label: 'getStarted.documetation.payoutsAPI.label',
      text: 'getStarted.documetation.payoutsAPI.text',
      link: 'payouts',
    },
  ],
};

export const limitDescription = {
  payments: {
    text: 'getStarted.limits.finOperations.text',
    icon: 'im-Finance',
  },
  rcs: { text: 'getStarted.limits.bwList.text', icon: 'im-Risk' },
  reports: { text: 'getStarted.limits.reports.text', icon: 'im-Reports' },
  team: { text: 'getStarted.limits.users.text', icon: 'im-Avatar' },
};
